import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-addContact",
  "use": "icon-addContact-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"icon-addContact\"><path d=\"M9.166 3.833a.667.667 0 1 0-1.333 0v4h-4a.667.667 0 0 0 0 1.334h4v4a.667.667 0 1 0 1.333 0v-4h4a.667.667 0 1 0 0-1.334h-4v-4Z\" fill=\"#4066D4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol